const numericCollator = new Intl.Collator(undefined, { numeric: true });

export const byNumericalFirst = (spaceA: any, spaceB: any): number => {
  const wordOrDigit = /\w/;

  // handles scenarios for null, undefined and symbols so they show up last
  if (!wordOrDigit.test(spaceA) || !spaceA) {
    return 1;
  }
  if (!wordOrDigit.test(spaceB) || !spaceB) {
    return -1;
  }
  // Sort numerically
  return numericCollator.compare(spaceA, spaceB);
};
